import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DaySettings} from "../../models/day-settings.model";
import {ModalController} from "@ionic/angular";
import {SelectDateComponent} from "../select-date/select-date.component";

@Component({
  selector: 'app-advanced-list-reservation-json-element',
  templateUrl: './advanced-list-reservation-json-element.component.html',
  styleUrls: ['./advanced-list-reservation-json-element.component.scss'],
})
export class AdvancedListReservationJsonElementComponent implements OnInit {

  @Input() daysSettings: DaySettings[];
  @Input() daysOnly: boolean = false;
  @Input() onlyHours: boolean = false;

  numbers: number[];
  dayToEdit: DaySettings;
  @Output() editListEmitter: EventEmitter<DaySettings[]> = new EventEmitter<DaySettings[]>();
  @Output() cancelEditListEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() addedDayEmitter: EventEmitter<number> = new EventEmitter<number>();


  constructor(private modalController: ModalController) {
  }

  ngOnInit() {
    console.log(this.daysSettings)
  }

  isEditMode(daySettings: DaySettings) {
    if (this.dayToEdit) {
      return this.dayToEdit.day === daySettings.day;
    } else {
      return false;
    }
  }

  editDay(value: DaySettings) {
    this.dayToEdit = value;
  }

  onHoursEdited(obj: DaySettings) {
    this.daysSettings = this.daysSettings.map(e => {
      if (e.day === obj.day) {
        e = obj;
      }
      return e;
    });
    this.dayToEdit = null;
    this.editListEmitter.emit(this.daysSettings);
  }

  onCancelEdit($event: boolean) {
    this.dayToEdit = null;
  }

  emitFullDayChange() {
    this.editListEmitter.emit(this.daysSettings);
  }

  async addDay(days: DaySettings[]) {
    const modal = await this.modalController.create({
      component: SelectDateComponent,
      componentProps: {
        'daysDefined': days,
        'notModalMode': true
      }
    });

    modal.onWillDismiss().then(e => {
      if (e && e.data) {
        this.handleDateSelected(e);
      }
    });

    return await modal.present();
  }

  private handleDateSelected(e) {
    let day = new DaySettings();
    day.day = e.data;
    day.isFullDay = false;
    day.startTime = null;
    day.endTime = null;
    this.daysSettings.push(day);
  }

  onRemoveDay(daySettings: any) {
    this.daysSettings = this.daysSettings.filter(e => e.day !== daySettings.day)
    this.editListEmitter.emit(this.daysSettings);
  }

  check() {
    console.log(this.daysSettings)
  }

  isStartAndEndTimeSelected(daySettings: DaySettings) {
    return daySettings.startTime && daySettings.endTime;
  }
}
